import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = (props) => {
    const getClassName = (client) => {
        let className = 'context-menu';
        if (props.selectedClient && props.selectedClient.id === client.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSValidateTypes,JSUnresolvedVariable
    return (
        <TableContainer><Table>
            <TableHead><TableRow>
                <TableCell className="username">Имя пользователя</TableCell>
                <TableCell className="offer">Оффер</TableCell>
            </TableRow></TableHead>
            <TableBody>
                {props.clients.map((client) => (
                    <TableRow key={client.id} className={getClassName(client)}
                              onContextMenu={props.onContextMenu(client)}
                    >
                        <TableCell className="username">
                            <Link to={`/users/${client.username}/`}>{client.username}</Link>
                        </TableCell>
                        <TableCell className="offer">
                            <Link to={`/offers/${client.offer.offer_name}/`}>{client.offer.offer_name}</Link>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table></TableContainer>
    );
};

Component.propTypes = {
    clients: PropTypes.array.isRequired,
    selectedClient: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
